import ru from "./ru"
import en from "./en"
import kk from "./kk"

export default {
    ru: ru,
    en: en,
    kk: kk,
}
